import { Injectable } from '@angular/core';
import { GenericRequestHandlerService } from '../../core/services/generic-request-handler.service';
import { ContactsService, MyLibraryService } from '../../api'

@Injectable({
    providedIn: 'root'
})
export class ContactsAppService {

    constructor(
        private genericRequestHandler: GenericRequestHandlerService,
        private api: ContactsService
    ) { }

    public contactList (content) {
        return this.api.contactListQuery(content)
    }

    public contactDetails (content) {
        return this.api.contactDetailsQuery(content)
    }

    public addContact = (content) => {
        return this.genericRequestHandler.callRequest(
            this.api.addContactHandler(content),
            'Kontakt został dodany'
        );
    }

    public editContact= (id, content) => {
        return this.genericRequestHandler.callRequest(
            this.api.editContactHandler(id, content),
            'Kontakt został zaktualizowany'
        );
    }

    public deleteContact= (id) => {
        return this.genericRequestHandler.callRequest(
            this.api.deleteContactHandler(id),
            'Kontakt został usunięty'
        );
    }
}
